import type { AuthResponse } from '@packages/shared/domain/auth/schemas/AuthResponseSchemas';
import type { CurrentUserResponse } from '@packages/shared/domain/user/schemas/UserResponseSchemas';
import type { LoginRequest } from '@packages/shared/domain/auth/schemas/AuthRequestSchemas';

import { HttpClient } from '@/lib/api/HttpClient';

const BASE_URL = '/auth';

export async function loginUser(credentials: LoginRequest): Promise<AuthResponse> {
	return HttpClient.post<AuthResponse>(`${BASE_URL}/login`, credentials, { auth: true });
}

export async function getCurrentUser(): Promise<CurrentUserResponse> {
	return HttpClient.get<CurrentUserResponse>(`${BASE_URL}/me`, { auth: true });
}

export async function logoutUser(): Promise<void> {
	return HttpClient.post<void>(`${BASE_URL}/logout`, {}, { auth: true });
}
